import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule, ProgressBarMode } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ts-loading-overlay',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatProgressBarModule],
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingOverlayComponent {
  @Input() message = 'info.loading_data';
  @Input() messageParams?: Record<string, unknown>;
  @Input() subMessage?: string;
  @Input() subMessageParams?: Record<string, unknown>;
  @Input() showProgressBar = false;
  @Input() progress?: number;
  @Input() progressMode: ProgressBarMode = 'determinate';
}
